module.exports = __webpack_public_path__ + "img/event2412_2_2.c0639d2b.jpg";